import { useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ColorModeContext } from '../contexts/ColorModeContext';
import { useZoom } from '../contexts/ZoomContext';
import { palette } from '../theme/colors';

const HEADER_HEIGHT = 56;

export const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { mode } = useContext(ColorModeContext);
  const { zoomContainerStyle } = useZoom();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const bgColor = mode === 'dark' ? palette.background : palette.light.background;

  return (
    <Box
      sx={{
        ...zoomContainerStyle,
        display: 'flex',
        minHeight: zoomContainerStyle.minHeight || '100vh',
        backgroundColor: bgColor,
      }}
    >
      <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
      <Header onMenuClick={handleDrawerToggle} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: `${HEADER_HEIGHT}px`,
          p: { xs: 2, sm: 3 },
          minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};
